'use client';

import { useEffect } from 'react';

/**
 * Safari 26 paints a flat sampled color behind the status bar until the page
 * has scrolled at least once, after which it composites real page pixels —
 * even back at the top. Nudging scroll by 1px on load flips it into
 * pixel-compositing mode so the hero photo shows edge-to-edge immediately.
 */
export default function StatusBarNudge() {
  useEffect(() => {
    if (window.location.hash || window.scrollY > 0) return;
    requestAnimationFrame(() => {
      window.scrollTo(0, 1);
    });
  }, []);

  return null;
}
